import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { DashboardMetrics, DashboardPeriod } from '@/types/dashboard';

const QUERY_KEY = 'dashboard';

/**
 * Fetch dashboard metrics with period filter
 * @param period - 'today' | 'week' | 'month' (default: 'today')
 */
export function useDashboard(period: DashboardPeriod = 'today') {
  return useQuery<DashboardMetrics>({
    queryKey: [QUERY_KEY, period],
    queryFn: async () => {
      const { data } = await api.get<DashboardMetrics>('/dashboard', {
        params: { period },
      });
      return data;
    },
  });
}
